import React from 'react';
import type { FC } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import type { Theme } from 'src/theme';
import ManualLinksForm from './ManualLinksForm';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

const RegisterGencodeView: FC = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Get Manual Links"
    >
      <Container maxWidth="lg">
        <ManualLinksForm />
      </Container>
    </Page>
  );
};

export default RegisterGencodeView;